// Sisäilmaolosuhteet — building scope renders the live Vyöhykkeet workspace directly, no
// Yhteenveto/Havainnot/Tapahtumaloki topic tabs; Havainnot reached
// on the zone axis via the Toiminto (story #960). Filters by Finding.source_type = "zone",
// never by Finding.category — Analyysi keeps `comfort`.
import { useEffect, useState } from "react";
import { Grid3x3 } from "lucide-react";
import { listZones } from "@/lib/api/building";
import { ZonesView } from "@/components/building/zones/ZonesView";
import { SectionPanel } from "@/components/ui/section-panel";
import { useInventoryFilter } from "@/lib/inventory-filter";
import { LensTopicSection } from "./LensTopicSection";
import { INDOOR_CONDITIONS_FINDINGS_FILTER } from "./lens-topic-metrics";

export function IndoorConditionsSection() {
  const { buildingId } = useInventoryFilter();
  const [zoneCount, setZoneCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!buildingId) {
      setZoneCount(null);
      return;
    }
    setZoneCount(null);
    listZones(buildingId)
      .then((zones) => !cancelled && setZoneCount(zones.length))
      .catch(() => !cancelled && setZoneCount(null));
    return () => {
      cancelled = true;
    };
  }, [buildingId]);

  return (
    <LensTopicSection
      eyebrow="Sisäilmaolosuhteet · näkymä"
      title="Miten vyöhykkeet voivat juuri nyt"
      description="Miten vyöhykkeet voivat juuri nyt · vyöhykeakseli."
      tracks={[
        {
          id: "zone",
          filter: INDOOR_CONDITIONS_FINDINGS_FILTER,
          label: "Sisäilmaolosuhteet",
          summaryOptions: { zoneCount },
          activityCategories: ["Konfiguraatio", "Analytiikka"],
          defaultEntityKind: "zone",
          findingsList: {
            ...INDOOR_CONDITIONS_FINDINGS_FILTER,
            emptyMessage: "Ei avoimia vyöhykehavaintoja.",
          },
          subHeaderSuffix: "sisäilmaolosuhteet",
          overviewCopy: {
            situationCardSubtitle: (count) =>
              count === 1
                ? "1 kiinteistössä avoimia vyöhykehavaintoja"
                : `${count} kiinteistössä avoimia vyöhykehavaintoja`,
            situationCardAllDoneLabel: "Ei avoimia vyöhykehavaintoja",
            emptyScopeHint: "Ei kiinteistöjä valitulla rajauksella",
            tileCompleteLabel: "Kunnossa",
            mapTitle: "Sisäilmaolosuhteiden kartta",
            mapSubtitle:
              "Missä vyöhykkeet tarvitsevat eniten huomiota — pallon koko = kiinteistöjä joilla avoimia vyöhykehavaintoja",
            mapLegendOkLabel: "Kunnossa",
            mapLegendWarnLabel: "Tarvitsee huomiota",
          },
        },
      ]}
      renderSummaryPanel={(id) => (
        <SectionPanel icon={Grid3x3} title="Vyöhykkeet">
          <ZonesView buildingId={id} operator={false} />
        </SectionPanel>
      )}
    />
  );
}
